import { render, staticRenderFns } from "./AdminVerticalNavMenu.vue?vue&type=template&id=d86a0ee2&scoped=true&"
import script from "./AdminVerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./AdminVerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminVerticalNavMenu.vue?vue&type=style&index=0&id=d86a0ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86a0ee2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VList,VNavigationDrawer})
